import React, { useEffect, useState } from "react";
import LayoutBase from "./LayoutBase";
import Swal from 'sweetalert2';
import "./Register.css";
import {
  PlusOutlined,
  MoreOutlined,
  CopyOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Radio,
  Row,
  Select,
  Table,
  message,
  TableColumnsType,
  Tooltip,
  RadioChangeEvent,
} from "antd";
import {
  HomeOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Item } from "react-use-cart";
import TableFooter from "../../components/AntdControlComponent/TableComponent/TableFooter";
import { ILogicRequestBody } from "../../IRequestModel/ILogicModel";
import { Column } from "primereact/column";
import { ColumnType } from "antd/lib/table";
import menu from "antd/lib/menu";
import layout from "antd/lib/layout";
import styled from "styled-components";
import { render } from "react-dom";
import { GetDepartment } from "../../Services/DepartmentService";
import { GetAllPosition } from "../../Services/PositionService";
import withReactContent from "sweetalert2-react-content";
import { GetDivision } from "../../Services/DivisonService";
import {
  GetAllEmployee,
  GetEmployeeValidation,
  GetUserData,
  GetUserEmpcode,
} from "../../Services/EmployeeService";
import { GetTemplateById } from "../../Services/TemplateService";
import {
  OpenApiEpro,
  OpenApiMemorandum,
} from "../../Services/e-pro/OpenApiEproService";
import { name } from "@azure/msal-browser/dist/packageMetadata";
import { GetAllDepDivSec, GetSection } from "../../Services/SectionService";

const { Option } = Select;
interface DirectorList {
  DirectorIdentification: number;
  DirectorTitle: string;
  DirectorFullName: string;
  DirectorPosition: string;
}

interface AuthorizedDirector {
  AuthorIdentification: number;
  AuthorTitle: string;
  AuthorFullName: string;
  AuthorPosition: string;
  AuthorType: string;
}

interface FormRegister {
  firstname_th: string;
  ListOfDirector: DirectorList[];
}
type Props = { responeConfig: any };
const Registerofficer: React.FC<Props> = ({ responeConfig }) => {
  const { control, register, handleSubmit, watch, formState, setValue } =
    useForm<FormRegister>();

  const {
  } = useFieldArray({
    control,
    name: "ListOfDirector",
  });

  const history = useHistory();

  const handleClick = () => {
    history.push("/login");
  };
  const [getItemD, setgetitemD] = useState([]);
  const [getItemP, setgetitemP] = useState([]);
  const [getItemDiv, setgetitemDiv] = useState([]);
  const [getItemSec, setgetitemSec] = useState([]);
  const [getAllRelateDep, setAllRelateDep] = useState<Department[]>([]);
  const MySwal = withReactContent(Swal);
  const getItem = async () => {
    let value = await GetDepartment();
    let value2 = await GetAllPosition();
    let value3 = await GetDivision();
    let value4 = await GetSection();
    let allitem = await GetAllDepDivSec();
    setgetitemD(value);
    setgetitemP(value2);
    setgetitemDiv(value3);
    setgetitemSec(value4);
    setAllRelateDep(allitem);
  };
  useEffect(() => {
    getItem();
  }, []);

  useEffect(() => {
    const initialValue = [
      {
        DirectorPosition: "",
        DirectorTitle: "",
        DirectorFullName: "",
        DirectorIdentification: 0,
      },
    ];
    setValue("ListOfDirector", initialValue);
  }, [setValue]);
  interface TableData2 {
    index: number;
    idFmis2: string;
    beforapprove: string;
  }
  interface TableData3 {
    index: number;
    idFmis3: string;
    approver: string;
  }
  interface TableData4 {
    index: number;
    idFmis4: string;
    approverbypay: string;
  }
  interface SubAccount {
    SoFSubID: number;
    SoFCode: string;
    SoFSubCode: string;
    SoFSubName: string;
    IsActive: boolean;
    CreatedBy: string;
    CreatedDate: string;
    ModifiedBy: string | null;
    ModifiedDate: string | null;
  }
  const [result, setresult] = useState<any>();
  const [showTable, setShowTable] = useState(false);
  const { Option } = Select;
  const [form] = Form.useForm();
  const [data2, setData2] = useState<TableData2[]>([]);
  const [data3, setData3] = useState<TableData3[]>([]);
  const [data4, setData4] = useState<TableData4[]>([]);
  const [empcode, setEmpcode] = useState("");

  const PermissionOptions = [
    {
      value: "1",
      label: "เจ้าหน้าที่ผู้ปฏิบัติงาน",
    },
    {
      value: "2",
      label: "หัวหน้างาน/หัวหน้าฝ่าย/ผู้บริหาร",
    },
    {
      value: "3",
      label: "ผู้ดูแลระบบ",
    },
  ];
  const WorkingStaffOptions: {
    [name: string]: Array<{ value: string; label: string }>;
  } = {
    "1": [
      {
        value: "A",
        label: "ผู้บันทึกสัญญา",
      },
      {
        value: "B",
        label: "ผู้ขอซื้อ",
      },
      {
        value: "C",
        label: "ผู้รับสินค้า",
      },
      {
        value: "D",
        label: "ผู้จัดทำงบใบสำคัญกรณีอื่น (PP)",
      },
    ],
    "2": [
      {
        value: "E",
        label: "ผู้อนุมัติของหน่วยงาน",
      },
      {
        value: "F",
        label: "ผู้ตรวจสอบ/ผู้อนุมัติใบขอซื้อ",
      },
      {
        value: "G",
        label: "ผู้อนุมัติ แก้ไขข้อมูลสัญญา",
      },
      {
        value: "H", label: "ผู้อนุมัติของสำนักจัดซื้อ"
      }
      ,
      {
        value: "I", label: "ผู้ประเมินของหน่วยงาน"
      }
    ],
    "3": [
      {
        value: "J",
        label: "Admin ",
      },
      {
        value: "K", label: "Central Admin"
      }

    ]
  }
  async function onFinish(values: any) {

    try {
      await form.validateFields();

      let selectedPermissions = PermissionOptions.filter((opt) =>
        values.Permis.includes(parseInt(opt.value)) // แปลง string เป็น int ก่อนเปรียบเทียบ
      );
      let workingStaff = values.Permis.flatMap((permis: any) =>
        WorkingStaffOptions[permis].filter((opt) =>
          values.workingStaff?.includes(opt.value)
        )
      );
      let workingAdmin = values.Permis.flatMap((permis: any) =>
        WorkingStaffOptions[permis].filter((opt) =>
          values.workingAdmin?.includes(opt.value)
        )
      );
      let workingHeader = values.Permis.flatMap((permis: any) =>
        WorkingStaffOptions[permis].filter((opt) =>
          values.workingHeader?.includes(opt.value)
        )
      );
      console.log("values", values)
      if (!empcode) {
        Swal.fire({
          title: 'ข้อผิดพลาด!',
          text: 'กรุณากรอกหมายเลขประจำตัวเจ้าหน้าที่.',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      const result: any = await GetEmployeeValidation({ Email: values.email, EmployeeCode: empcode });
      console.log("result:", result);

      const employee = result.result;
      if (employee) {
        if (selectedPermissions.some(perm => perm.value === "1" && workingStaff.some((opt: { value: string; }) => opt.value === "D")) && (data2.length <= 0 || data3.length <= 0 || data4.length <= 0)) {
          Swal.fire({
            title: 'ข้อผิดพลาด!',
            text: 'กรุณากรอกข้อมมูลในตาราง.',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          });
        }
        else {
          Swal.fire({
            title: 'กำลังบันทึกข้อมูล...',
            text: 'กรุณารอสักครู่...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
          console.log("Form values:", values);
          console.log("Table data2:", data2);
          console.log("Table data3:", data3);
          console.log("Table data4:", data4);

          let mapFormToValue: { [name: string]: string } = {
            รหัสบุคลากร: "staff_id",
            "ชื่อ (ภาษาไทย)": "firstname_th",
            "นามสกุล (ภาษาไทย)": "lastname_th",
            "ชื่อ (ภาษาอังกฤษ)": "firstname_en",
            "นามสกุล (ภาษาอังกฤษ)": "lastname_en",
            ตำแหน่ง: "position",
            "งาน": "section",
            "ฝ่าย": "division",
            "หน่วยงาน": "department",
            เบอร์โทรศัพท์: "mobile",
            มือถือ: "phone",
            "E-mail": "email",
            หัวหน้างาน: "reportTo",
            "Username บusะบบ FMIS ": "fmis_username",
            "เลขประจำตัว บนระบบ FMIS ": "fmis_number",
          };

          let result = await OpenApiEpro();

          result.form = result.form.map((item) => {
            let valueKey = mapFormToValue[item.template.label];
            if (valueKey != null) {
              item.data.value = values[valueKey];
            }
            if (item.template.label == "เรื่อง") {
              result.subject = item.data.value + values.staff_id + " " + values.firstname_th + " " + values.lastname_th;
              item.data.value = item.data.value + values.staff_id + " " + values.firstname_th + " " + values.lastname_th;
            }
            if (item.template.label == "สิทธิ์เข้าใช้งาน") {
              item.data.value = selectedPermissions.map(perm => perm.label).join(",");
            }
            if (item.template.label == "เจ้าหน้าที่ผู้ปฏิบัติงาน" && item.template.alter !== "(กรณีเป็นผู้จัดทำงบใบสำคัญ)") {
              item.data.value = workingStaff.map((perm: { label: any; }) => perm.label).join(",");
            }
            if (item.template.label == "หัวหน้างาน/หัวหน้าฝ่าย/ผู้บริหาร") {
              item.data.value = workingHeader.map((perm: { label: any; }) => perm.label).join(",");
            }
            if (item.template.label == "ผู้ดูแลระบบ") {
              item.data.value = workingAdmin.map((perm: { label: any; }) => perm.label).join(",");
            }

            if (item.template.label === "เจ้าหน้าที่ผู้ปฏิบัติงาน " && item.template.alter === "(กรณีเป็นผู้จัดทำงบใบสำคัญ)") {
              item.data.value = workingStaff?.map((opt: { label: any; }) => opt.label).join(",");
            }
            if (
              selectedPermissions.some(perm => perm.value === "1") &&
              workingStaff.some((opt: { value: string; }) => opt.value === "D")
            ) {
              if (item.template.label == "ผู้ตรวจก่อนอนุมัติจ่าย") {

                let columnNames = ["idFmis", "beforapprove"];
                item.data.row = data2.map((row: any) => {
                  let newRow2 = columnNames.map((col) => {
                    return { value: row[col] };
                  });
                  return newRow2;
                });
              }
              if (item.template.label == "ผู้อนุมัติงบใบสำคัญ") {
                let columnNames = ["idFmis", "approver"];
                item.data.row = data3.map((row: any) => {
                  let newRow3 = columnNames.map((col) => {
                    return { value: row[col] };
                  });
                  return newRow3;
                });
              }
              if (item.template.label == "ผู้อนุมัติเบิกจ่ายงบประมาณ") {
                let columnNames = ["idFmis", "approverbypay"];
                item.data.row = data4.map((row: any) => {
                  let newRow4 = columnNames.map((col) => {
                    return { value: row[col] };
                  });
                  return newRow4;
                });
              }
            }
            return item;
          });

          await OpenApiMemorandum(result);

          // แสดง SweetAlert2 เมื่อลงทะเบียนสำเร็จ
          Swal.fire({
            title: 'สำเร็จ!',
            text: 'ข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว.',
            icon: 'success',
            confirmButtonText: 'ตกลง'
          }).then((result) => {
            if (result.isConfirmed) {
              history.push('/login');
            }
          });

          console.log("result", result);
          console.log("Received values of form: ", values);
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'มีข้อมูลอยู่ในระบบแล้ว!',
          text: 'มีข้อมูลอยู่ในระบบแล้ว ไม่สามารถลงทะเบียนซ้ำได้!',
          confirmButtonText: 'ตกลง'
        });
      }
    } catch (error) {
      console.error("Validate Failed:", error);
      Swal.fire({
        title: 'ข้อผิดพลาด!',
        text: 'ไม่สามารถบันทึกข้อมูลได้.',
        icon: 'error',
        confirmButtonText: 'ตกลง'
      });
    }
  }

  const onChick = async () => {

  };
  const [valueRadio, setValueRadio] = useState<(number | string)[]>([]);
  const onChangeRadio = (e: any) => {
    setValueRadio(e);
    console.log("e", e)
  };

  useEffect(() => {
    if (result) {
      form.setFieldsValue({ firstname_th: result.FirstNameTh });
      form.setFieldsValue({ lastname_th: result.LastNameTh });
      form.setFieldsValue({ firstname_en: result.FirstNameEn });
      form.setFieldsValue({ lastname_en: result.LastNameEn });
      form.setFieldsValue({ position: result.NameThP });
      form.setFieldsValue({ department: result.NameThD });
      form.setFieldsValue({ division: result.NameThDiv });
      form.setFieldsValue({ section: result.SectionName });
      form.setFieldsValue({ phone: result.TelNo });
      form.setFieldsValue({ mobile: result.TelMobile });
      form.setFieldsValue({ email: result.Email });
      form.setFieldsValue({ reportTo: result.NameReportToEmpCodde });
    }
  }, [result]);

  const addRow2 = () => {
    const newRow2: TableData2 = {
      index: data2.length + 1,
      idFmis2: "",
      beforapprove: "",
    };
    setData2([...data2, newRow2]);
  };

  const addRow3 = () => {
    const newRow3: TableData3 = {
      index: data3.length + 1,
      idFmis3: "",
      approver: "",
    };
    setData3([...data3, newRow3]);
  };
  const addRow4 = () => {
    const newRow4: TableData4 = {
      index: data4.length + 1,
      idFmis4: "",
      approverbypay: "",
    };
    setData4([...data4, newRow4]);
  };

  const handleCheckboxChange = async (e: { target: { checked: boolean | ((prevState: boolean) => boolean) }; }) => {
    setShowTable(e.target.checked);
  };

  const handleMenuClick2 = (key: string, record: TableData2, i: number) => {
    if (key === "delete") {
      const newData = data2.filter((_, index) => index !== i);
      setData2(newData);
    } else if (key === "copy") {
      const newRecord2 = { ...record, index: data2.length + 1 };
      setData2([...data2, newRecord2]);
    }
  };
  const handleMenuClick3 = (key: string, record: TableData3, i: number) => {
    if (key === "delete") {
      const newData = data3.filter((_, index) => index !== i);
      setData3(newData);
    } else if (key === "copy") {
      const newRecord3 = { ...record, index: data3.length + 1 };
      setData3([...data3, newRecord3]);
    }
  };
  const handleMenuClick4 = (key: string, record: TableData4, i: number) => {
    if (key === "delete") {
      const newData = data4.filter((_, index) => index !== i);
      setData4(newData);
    } else if (key === "copy") {
      const newRecord4 = { ...record, index: data4.length + 1 };
      setData4([...data4, newRecord4]);
    }
  };
  const menu2 = (record: TableData2, i: number) => (
    <Menu onClick={({ key }) => handleMenuClick2(key, record, i)}>
      <Menu.Item
        key="delete"
        icon={<DeleteOutlined rev={undefined} />}
        className="custom-menu-item"
      >
        Delete
      </Menu.Item>
      <Menu.Item
        key="copy"
        icon={<CopyOutlined rev={undefined} />}
        className="custom-menu-item"
      >
        Copy
      </Menu.Item>
    </Menu>
  );
  const menu3 = (record: TableData3, i: number) => (
    <Menu onClick={({ key }) => handleMenuClick3(key, record, i)}>
      <Menu.Item
        key="delete"
        icon={<DeleteOutlined rev={undefined} />}
        className="custom-menu-item"
      >
        Delete
      </Menu.Item>
      <Menu.Item
        key="copy"
        icon={<CopyOutlined rev={undefined} />}
        className="custom-menu-item"
      >
        Copy
      </Menu.Item>
    </Menu>
  );
  const menu4 = (record: TableData4, i: number) => (
    <Menu onClick={({ key }) => handleMenuClick4(key, record, i)}>
      <Menu.Item
        key="delete"
        icon={<DeleteOutlined rev={undefined} />}
        className="custom-menu-item"
      >
        Delete
      </Menu.Item>
      <Menu.Item
        key="copy"
        icon={<CopyOutlined rev={undefined} />}
        className="custom-menu-item"
      >
        Copy
      </Menu.Item>
    </Menu>
  );
  const handleDropdownChange2 = (value: string, key: string, index: number) => {
    const newData = [...data2];
    newData[index] = { ...newData[index], [key]: value };
    setData2(newData);
  };
  const handleDropdownChange3 = (value: string, key: string, index: number) => {
    const newData = [...data3];
    newData[index] = { ...newData[index], [key]: value };
    setData3(newData);
  };
  const handleDropdownChange4 = (value: string, key: string, index: number) => {
    const newData = [...data4];
    newData[index] = { ...newData[index], [key]: value };
    setData4(newData);
  };

  const columns2 = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "3%",
      render: (_: any, __: any, i: number) => {
        return i + 1;
      },
    },
    {
      title: (
        <span style={{ fontSize: "16px" }}>
          รหัสประจำตัว บนระบบ FMIS<span style={{ color: "red" }}> *</span>
        </span>
      ),
      dataIndex: "idFmis",
      key: "idFmis",
      width: "20%",
      render: (_: any, record: TableData2, index: number) => (
        <Form.Item
          name={`idFmis2_${index}`}
          rules={[{ required: true, message: 'กรุณากรอกรหัสประจำตัว บนระบบ FMIS!' }]}
        >
          <Input
            value={record.idFmis2}
            onChange={(e) => handleDropdownChange2(e.target.value, "idFmis", index)}
            style={{ width: "100%", maxWidth: "350px" }}
          />
        </Form.Item>
      ),
    },
    {
      title: (
        <span style={{ fontSize: "16px" }}>
          ผู้ตรวจก่อนอนุมัติจ่าย<span style={{ color: "red" }}> *</span>
        </span>
      ),
      dataIndex: "beforapprove",
      key: "beforapprove",
      width: "20%",
      render: (_: any, record: TableData2, index: number) => (
        <Form.Item
          name={`beforapprove_${index}`} // ใช้ index เพื่อให้แต่ละฟิลด์ไม่ซ้ำกัน
          rules={[{ required: true, message: 'กรุณาเลือกผู้ตรวจก่อนอนุมัติจ่าย!' }]} // การตรวจสอบค่า
        >
          <Input
            value={record.beforapprove}
            onChange={(e) =>
              handleDropdownChange2(e.target.value, "beforapprove", index)
            }
            style={{ width: "100%" }}
            placeholder="กรุณาผู้ตรวจก่อนอนุมัติจ่าย"
          />
        </Form.Item>
      ),
    },
    {
      title: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Button
            type="primary"
            icon={<PlusOutlined rev={undefined} />}
            onClick={addRow2}
            style={{
              backgroundColor: "unset",
              border: "none",
              color: "black",
              boxShadow: "none",
            }}
          />
        </div>
      ),
      key: "action",
      fixed: "right" as "right", // Ensure 'fixed' is of type 'right'
      width: "5%",
      render: (_: any, record: TableData2, i: number) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Dropdown overlay={menu2(record, i)} trigger={["click"]}>
            <Button
              icon={<MoreOutlined rev={undefined} />}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
              }}
            />
          </Dropdown>
        </div>
      ),
    },
  ];
  const columns3 = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "3%",
      render: (_: any, __: any, i: number) => {
        return i + 1;
      },
    },
    {
      title: (
        <span style={{ fontSize: "16px" }}>
          รหัสประจำตัว บนระบบ FMIS<span style={{ color: "red" }}> *</span>
        </span>
      ),
      dataIndex: "idFmis",
      key: "idFmis",
      width: "20%",
      render: (_: any, record: TableData3, index: number) => (
        <Form.Item
          name={`idFmis3_${index}`}
          rules={[{ required: true, message: 'กรุณากรอกรหัสประจำตัว บนระบบ FMIS!' }]}
        >
          <Input
            value={record.idFmis3}
            onChange={(e) => handleDropdownChange3(e.target.value, "idFmis", index)}
            style={{ width: "100%", maxWidth: "350px" }}
          >
          </Input>
        </Form.Item>

      ),
    },
    {
      title: (
        <span style={{ fontSize: "16px" }}>
          ผู้อนุมัติงบใบสำคัญ<span style={{ color: "red" }}> *</span>
        </span>
      ),

      dataIndex: "approver",
      key: "approver",
      width: "20%",
      render: (_: any, record: TableData3, index: number) => (
        <Form.Item
          name={`approver_${index}`} // ใช้ index เพื่อให้ชื่อฟิลด์ไม่ซ้ำกัน
          rules={[{ required: true, message: 'กรุณาเลือกผู้อนุมัติงบใบสำคัญ!' }]} // การตรวจสอบค่า
        >
          <Input
            value={record.approver}
            onChange={(e) => handleDropdownChange3(e.target.value, "approver", index)}
            style={{ width: "100%" }}
            placeholder="กรุณาเลือกผู้อนุมัติงบใบสำคัญ"
          />
        </Form.Item>
      ),
    },
    {
      title: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Button
            type="primary"
            icon={<PlusOutlined rev={undefined} />}
            onClick={addRow3}
            style={{
              backgroundColor: "unset",
              border: "none",
              color: "black",
              boxShadow: "none",
            }}
          />
        </div>
      ),
      key: "action",
      fixed: "right" as "right", // Ensure 'fixed' is of type 'right'
      width: "5%",
      render: (_: any, record: TableData3, i: number) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Dropdown overlay={menu3(record, i)} trigger={["click"]}>
            <Button
              icon={<MoreOutlined rev={undefined} />}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
              }}
            />
          </Dropdown>
        </div>
      ),
    },
  ];
  const columns4 = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "3%",
      render: (_: any, __: any, i: number) => {
        return i + 1;
      },
    },
    {
      title: (
        <span style={{ fontSize: "16px" }}>
          รหัสประจำตัว บนระบบ FMIS<span style={{ color: "red" }}> *</span>
        </span>
      ),
      dataIndex: "idFmis",
      key: "idFmis",
      width: "20%",
      render: (_: any, record: TableData4, index: number) => (
        <Form.Item
          name={`idFmis4_${index}`}
          rules={[{ required: true, message: 'กรุณากรอกรหัสประจำตัว บนระบบ FMIS!' }]}
        >
          <Input
            value={record.idFmis4}
            onChange={(e) => handleDropdownChange4(e.target.value, "idFmis", index)}
            style={{ width: "100%", maxWidth: "350px" }}
          >
          </Input>
        </Form.Item>

      ),
    },
    {
      title: (
        <span style={{ fontSize: "16px" }}>
          ผู้อนุมัติเบิกจ่ายงบประมาณ<span style={{ color: "red" }}> *</span>
        </span>
      ),
      dataIndex: "approverbypay",
      key: "approverbypay",
      width: "20%",
      render: (_: any, record: TableData4, index: number) => (
        <Form.Item
          name={`approverbypay_${index}`} // ใช้ index เพื่อให้ชื่อไม่ซ้ำกันในแต่ละแถว
          rules={[{ required: true, message: 'กรุณาเลือกผู้อนุมัติเบิกจ่ายงบประมาณ!' }]} // การตรวจสอบค่า
        >
          <Input
            value={record.approverbypay}
            onChange={(e) => handleDropdownChange4(e.target.value, "approverbypay", index)}
            style={{ width: "100%" }}
            placeholder="กรุณาเลือกผู้อนุมัติเบิกจ่ายงบประมาณ"
          />
        </Form.Item>
      ),
    },
    {
      title: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Button
            type="primary"
            icon={<PlusOutlined rev={undefined} />}
            onClick={addRow4}
            style={{
              backgroundColor: "unset",
              border: "none",
              color: "black",
              boxShadow: "none",
            }}
          />
        </div>
      ),
      key: "action",
      fixed: "right" as "right", // Ensure 'fixed' is of type 'right'
      width: "5%",
      render: (_: any, record: TableData4, i: number) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Dropdown overlay={menu4(record, i)} trigger={["click"]}>
            <Button
              icon={<MoreOutlined rev={undefined} />}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
              }}
            />
          </Dropdown>
        </div>
      ),
    },
  ];
  const sideBar = <div></div>;
  interface Department {
    DepartmentCode: string;
    DivisionCode: string;
    SectionCode: string | null;
    DepartmentName: string;
    DivisionName: string;
    SectionName: string;
  }



  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedDivision, setSelectedDivision] = useState(null);


  // ฟิลเตอร์ข้อมูลของ divisions ตาม department ที่เลือก
  const filteredDivisions = getAllRelateDep.filter(
    (item) => item.DepartmentName === selectedDepartment
  );

  // ฟิลเตอร์ข้อมูลของ sections ตาม division ที่เลือก
  const filteredSections = getAllRelateDep.filter(
    (item) => item.DivisionName === selectedDivision
  );

  return (
    <LayoutBase responeConfig={responeConfig} sideMenu={sideBar}>
      <Form
        layout="horizontal"
        name="wrap"
        form={form}
        labelCol={{ flex: "110px" }}
        labelAlign="left"
        labelWrap
        wrapperCol={{ flex: 1 }}
        colon={false}
        onFinish={onFinish}
      >
        <div style={{ display: "grid", rowGap: "20px" }}>
          <div style={{ borderRadius: "8px" }}>
            <div className="container-input">
              <div className="header-content" style={{ marginBottom: "20px" }}>
                จัดการบัญชีผู้ใช้และสิทธิ์เข้าใช้งาน
              </div>
              <div className="header-content">ส่วนที่ 1 ข้อมูลผู้ใช้งาน</div>
              <div className="content-form">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridTemplateRows: "auto",
                    gap: "20px",
                  }}
                >
                  <Form.Item
                    label={
                      <div style={{ fontSize: "15px" }}>
                        รหัสบุคลากร
                        <div style={{ color: "gray", fontSize: "12px" }}>
                          หมายเลขประจำตัวเจ้าหน้าที่ 7 หลัก
                        </div>
                      </div>
                    }
                    name="staff_id"
                    rules={[
                      { required: true, message: "กรุณากรอกรหัสบุคลากร" },
                    ]}
                  >
                    <Input
                      placeholder="รหัสบุคลากร"
                      value={empcode}
                      onPressEnter={onChick}
                      onChange={(e) => setEmpcode(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item>
                    {}
                  </Form.Item>
                  <Form.Item
                    label="ชื่อ (ภาษาไทย)"
                    name="firstname_th"
                    rules={[
                      { required: true, message: "ชื่อ (ภาษาไทย)" },
                    ]}
                  >
                    <Input
                      placeholder="ชื่อ (ภาษาไทย)"
                      className="read-only-input"
                    />
                  </Form.Item>

                  <Form.Item
                    label="นามสกุล (ภาษาไทย)"
                    name="lastname_th"
                    rules={[
                      { required: true, message: "นามสกุล (ภาษาไทย)" },
                    ]}
                  >
                    <Input
                      placeholder="นามสกุล (ภาษาไทย)"
                      className="read-only-input"
                    />
                  </Form.Item>

                  <Form.Item
                    label="ชื่อ (ภาษาอังกฤษ)"
                    name="firstname_en"
                    rules={[
                      { required: true, message: "ชื่อ (ภาษาอังกฤษ)" },
                    ]}
                  >
                    <Input
                      placeholder="ชื่อ (ภาษาอังกฤษ)"
                      className="read-only-input"
                    />
                  </Form.Item>

                  <Form.Item
                    label="นามสกุล (ภาษาอังกฤษ)"
                    name="lastname_en"
                    rules={[
                      { required: true, message: "นามสกุล (ภาษาอังกฤษ)" },
                    ]}
                  >
                    <Input
                      placeholder="นามสกุล (ภาษาอังกฤษ)"
                      className="read-only-input"
                    />
                  </Form.Item>
                  <Form.Item
                    label="ตำแหน่ง"
                    name="position"
                    className="custom-select5"
                    rules={[
                      { required: true, message: "ตำแหน่ง" },
                    ]}
                  >
                    <Select
                      placeholder="เลือกตำแหน่ง"
                      className="read-only-input"
                      showSearch
                      allowClear
                    >
                      {getItemP.map((item: any, index) => (
                        <Option key={index} value={item.NameTh}>
                          {item.NameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item></Form.Item>
                  <Form.Item 
                    label="หน่วยงาน" 
                    name="department"
                    rules={[
                      { required: true, message: "หน่วยงาน" },
                    ]}
                  >
                    <Select
                      placeholder="เลือกหน่วยงาน"
                      className="read-only-input"
                      showSearch
                      allowClear
                      onChange={(value) => {
                        setSelectedDepartment(value); // เมื่อเลือกหน่วยงาน ให้เก็บค่าใน state
                        setSelectedDivision(null); // รีเซ็ต division เมื่อเลือกหน่วยงานใหม่
                      }}
                    >
                      {[
                        ...new Set(
                          getAllRelateDep.map((item) => item.DepartmentName) // กรองหน่วยงานที่ไม่ซ้ำกัน
                        ),
                      ].map((department, index) => (
                        <Option key={index} value={department}>
                          {department}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  {/* Dropdown สำหรับเลือกฝ่าย */}
                  <Form.Item 
                    label="ฝ่าย" 
                    name="division"
                  >
                    <Select
                      className="custom-select4"
                      placeholder="เลือกฝ่าย"
                      showSearch
                      allowClear
                      onChange={(value) => setSelectedDivision(value)}
                      disabled={!selectedDepartment}
                    >
                      {[...new Set(
                        filteredDivisions.map((item) => item.DivisionName)
                      )].map((division, index) => (
                        <Option key={index} value={division} className="select-option">
                          {division}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>


                  {/* Dropdown สำหรับเลือกงาน */}
                  <Form.Item label="งาน" name="section">
                    <Select
                      placeholder="เลือกงาน"
                      className="custom-select4"
                      showSearch
                      allowClear
                      disabled={!selectedDivision}
                    >
                      {[...new Set(
                        filteredSections
                          .filter(item => item.SectionName && item.SectionName !== "-")
                          .map(item => item.SectionName)
                      )].map((sectionName, index) => (
                        <Option key={index} value={sectionName}>
                          {sectionName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item 
                    label="เบอร์โทรศัพท์" 
                    name="phone"
                    rules={[{ required: true, message: 'เบอร์โทรศัพท์' }]}
                  >
                    <Input
                      placeholder="เบอร์โทรศัพท์"
                      className="read-only-input"
                    />
                  </Form.Item>

                  <Form.Item label="มือถือ" name="mobile">
                    <Input
                      placeholder="มือถือ"
                      className="read-only-input"
                    />
                  </Form.Item>

                  <Form.Item
                    label="E-mail"
                    name="email"
                    rules={[{ required: true, message: 'กรุณากรอก E-mail' }]}
                  >
                    <Input
                      placeholder="E-mail"
                      className="read-only-input"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
          <div style={{ borderRadius: "8px" }}>
            <div className="container-input" style={{ paddingBottom: "30px" }}>
              <div className="header-content">ส่วนที่ 2 สิทธิของผู้ใช้งาน</div>

              <div className="content-form">
                <div style={{ fontWeight: "bolder" }}>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      fontWeight: "bolder",
                    }}
                  >
                    <Form.Item
                      label="สิทธิ์เข้าใช้งาน"
                      name="Permis"
                      rules={[
                        { required: true, message: "กรุณาเลือกสิทธิ์เข้าใช้งาน" },
                      ]}
                    >
                      <Checkbox.Group
                        onChange={onChangeRadio}
                        value={valueRadio}
                      >
                        <Checkbox style={{ fontSize: "15px" }} value={1}>
                          เจ้าหน้าที่ผู้ปฏิบัติงาน
                        </Checkbox>
                        <Checkbox style={{ fontSize: "15px" }} value={2}>
                          หัวหน้างาน/หัวหน้าฝ่าย/ผู้บริหาร
                        </Checkbox>
                        <Checkbox style={{ fontSize: "15px" }} value={3}>
                          ผู้ดูแลระบบ
                        </Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </div>

                </div>

                <div
                  style={{
                    display: "grid",
                    // gridTemplateColumns: "0.7fr 1.3fr",
                    gridTemplateRows: "auto",
                    rowGap: "8px",
                  }}
                >
                  {valueRadio.includes(1) && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          fontWeight: "bolder",
                          width: "950px",
                        }}
                      >
                        <Form.Item
                          label="เจ้าหน้าที่ผู้ปฏิบัติงาน"
                          name="workingStaff"
                          rules={[
                            {
                              required: true,
                              message: "กรุณาเลือกอย่างน้อยหนึ่งรายการ",
                            },
                          ]}
                        >
                          <Checkbox.Group
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                            }}
                          >
                            <Checkbox value="A" style={{ fontSize: "14px" }}>
                              ผู้บันทึกสัญญา
                            </Checkbox>
                            <Checkbox value="B" style={{ fontSize: "14px" }}>
                              ผู้ขอซื้อ
                            </Checkbox>
                            <Checkbox value="C" style={{ fontSize: "14px" }}>
                              ผู้รับสินค้า
                            </Checkbox>
                            <Checkbox
                              value="D"
                              onChange={handleCheckboxChange}
                              style={{ fontSize: "14px" }}
                            >
                              ผู้จัดทำงบใบสำคัญกรณีอื่น (PP)
                            </Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                      </div>
                    </>
                  )}

                  {valueRadio.includes(2) && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          fontWeight: "bolder",
                          width: "1000px",
                        }}
                      >
                        <Form.Item
                          label={
                            <span style={{ whiteSpace: 'nowrap' }}>
                              หัวหน้างาน/หัวหน้าฝ่าย/ผู้บริหาร
                            </span>
                          }
                          name="workingHeader"
                          rules={[
                            {
                              required: true,
                              message: "กรุณาเลือกอย่างน้อยหนึ่งรายการ",
                            },
                          ]}
                        >
                          <Checkbox.Group style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                            <Checkbox value="E" style={{ fontSize: "14px" }}>ผู้อนุมัติของหน่วยงาน</Checkbox>
                            <Checkbox value="F" style={{ fontSize: "14px" }}>ผู้ตรวจสอบ/ผู้อนุมัติใบขอซื้อ</Checkbox>
                            <Checkbox value="G" style={{ fontSize: "14px" }}>ผู้อนุมัติ แก้ไขข้อมูลสัญญา</Checkbox>
                            <Checkbox value="H" style={{ fontSize: "14px" }}>ผู้อนุมัติของสำนักจัดซื้อ</Checkbox>
                            <Checkbox value="I" style={{ fontSize: "14px" }} >ผู้ประเมินของหน่วยงาน</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                      </div>
                    </>
                  )}
                  {valueRadio.includes(3) && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          fontWeight: "bolder",
                          width: "950px",
                        }}
                      >
                        <Form.Item
                          label="ผู้ดูแลระบบ"
                          name="workingAdmin"
                          rules={[
                            {
                              required: true,
                              message: "กรุณาเลือกอย่างน้อยหนึ่งรายการ",
                            },
                          ]}
                        >
                          <Checkbox.Group style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                            <Checkbox value="J" style={{ fontSize: "14px" }}>Admin</Checkbox>
                            <Checkbox value="K" style={{ fontSize: "14px" }}>Central Admin</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {showTable && (
                <>
                  <div className="content-form">
                    <div
                      // form={form2}
                      // layout="horizontal"
                      // name="wrap"
                      // labelCol={{ flex: '110px' }}
                      // labelAlign="left"
                      // labelWrap
                      // wrapperCol={{ flex: 1 }}
                      // colon={false}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gridTemplateRows: "auto",
                        gap: "20px",
                      }}
                    >
                      <Form.Item></Form.Item>
                      <Form.Item
                        label={
                          <div>
                            Username บนระบบ FMIS
                            <div style={{ color: "gray", fontSize: "14px" }}>
                              (กรณีเป็นผู้จัดทำงบใบสำคัญ)
                            </div>
                          </div>
                        }
                        name="fmis_username"
                        rules={[{ required: true, message: 'กรุณากรอก Username บนระบบ FMIS' }]}
                      >
                        <Input placeholder="Username บนระบบ FMIS" />
                      </Form.Item>
                      <Form.Item></Form.Item>
                      <Form.Item
                        label={
                          <div>
                            เลขประจำตัว บนระบบ FMIS
                            <div style={{ color: "gray", fontSize: "14px" }}>
                              (กรณีเป็นผู้จัดทำงบใบสำคัญ)
                            </div>
                          </div>
                        }
                        name="fmis_number"
                        rules={[{ required: true, message: 'กรุณากรอก เลขประจำตัว บนระบบ FMIS' }]}
                      >
                        <Input placeholder="เลขประจำตัว บนระบบ FMIS" />
                      </Form.Item>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                      fontWeight: "bolder",
                      width: "250px",
                      marginLeft: "30px",
                    }}
                  >
                    <div>
                      ผู้ตรวจก่อนอนุมัติจ่าย
                      <br />
                      <span style={{ color: "gray" }}> (สามารถเลือกได้มากกว่า 1 รายการ)</span>
                    </div>


                  </div>

                  <div style={{ position: "relative", marginBottom: "20px" }}>
                    <Table
                      className="padding-controller control-table"
                      dataSource={data2}
                      columns={columns2}
                      bordered
                      id="table-control"
                      pagination={false}
                      rowKey={(record, index) => index!.toString()}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                      fontWeight: "bolder",
                      width: "250px",
                      marginLeft: "30px",
                    }}
                  >
                    <div>
                      ผู้อนุมัติงบใบสำคัญ
                      <br />
                      <span style={{ color: "gray" }}> (สามารถเลือกได้มากกว่า 1 รายการ)</span>
                    </div>

                  </div>
                  <div style={{ position: "relative", marginBottom: "20px" }}>
                    <Table
                      className="padding-controller control-table"
                      dataSource={data3}
                      columns={columns3}
                      bordered
                      id="table-control"
                      pagination={false}
                      rowKey={(record, index) => index!.toString()}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                      fontWeight: "bolder",
                      width: "250px",
                      marginLeft: "30px",
                    }}
                  >
                    <div>
                      ผู้อนุมัติเบิกจ่ายงบประมาณ
                      <br />
                      <span style={{ color: "gray" }}> (สามารถเลือกได้มากกว่า 1 รายการ)</span>
                    </div>

                  </div>
                  <div style={{ position: "relative" }}>
                    <Table
                      className="padding-controller control-table"
                      dataSource={data4}
                      columns={columns4}
                      bordered
                      id="table-control"
                      pagination={false}
                      rowKey={(record, index) => index!.toString()}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              columnGap: "10px",
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              style={{
                height: "60px",
                color: "white",
                width: "200px",
                fontSize: "20px",
                fontWeight: "bold",
                backgroundColor: "#6598F6",
                borderRadius: "6px",
                marginBottom: "80px",
              }}
            >
              บันทึกข้อมูล
            </Button>
            <Button
              style={{
                height: "60px",
                color: "white",
                width: "200px",
                fontSize: "20px",
                fontWeight: "bold",
                borderRadius: "6px",
                backgroundColor: "#C95559",
              }}
              onClick={handleClick}
            >
              ปิด
            </Button>
          </div>
        </div>
      </Form>
    </LayoutBase >
  );
};

export default Registerofficer;
